import _ from "@lodash";
import { Grid, MenuItem, TextField, withStyles } from "@material-ui/core";
import { red } from "@material-ui/core/colors";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import "rsuite/dist/styles/rsuite-default.css";

const Slider = React.lazy(() =>
    import("rsuite").then(module => {
        return { default: module.Slider };
    })
);

const styles = theme => ({
    root: {
        color: theme.palette.text.primary,
        flexGrow: 1,
    },
    productImageFeaturedClear: {
        position: "absolute",
        top: 0,
        right: 0,
        color: red[400],
        opacity: 0,
        backgroundColor: "#fff"
    },
    productImageItem: {
        height: "auto",
        transitionProperty: "box-shadow",
        transitionDuration: theme.transitions.duration.short,
        transitionTimingFunction: theme.transitions.easing.easeInOut,
        "&:hover": {
            boxShadow: theme.shadows[5],
            "& $productImageFeaturedClear": {
                opacity: 1,
                backgroundColor: "#fff"
            }
        },
        alignItems: "center",
        justifyContent: "center",
        marginRight: "16px",
        marginBottom: "16px",
        border: "1px solid #666"
    },
    container: {
    },
    slider: {
        "&.rs-slider-progress-bar": {
            background: theme.palette.primary.main
        }
    }
});

class Visualizacao01 extends XAPPComponent {

    state = {
        colunas: 1,
        zoom: {},
        loading: false,
    };

    componentDidMount() {
        var AState = JSON.parse(JSON.stringify(this.state));
        AState.colunas = this.props.selected.length;
        AState.loading = true;
        this.props.selected.forEach(item => {
            AState.zoom[item.idarquivo] = 25;
        });
        this.setState(AState);
    }

    changeZoom = (_AValue, _AIDArquivo) => {
        this.setState({ zoom: _.set({ ...this.state.zoom }, _AIDArquivo, _AValue) });
    };

    getImagem = (_AArquivo) => {
        const { zoom, colunas } = this.state;
        const { classes } = this.props;
        var item = _AArquivo;
        var colClass = [];
        colClass[1] = 12;
        colClass[2] = 6;
        colClass[3] = 4;
        colClass[4] = 3;
        colClass[5] = 2;
        colClass[6] = 2;

        var element = document.getElementById("galeriaDialogContent");
        if (element !== null) {
            var AHeight = element.clientHeight * .85;
            var AWidth = (element.clientWidth * .95) / colunas;
        }

        var element1 = document.getElementById("divMainImg_" + item.idarquivo);
        if (!_.isUndefined(element1) && !_.isNull(element1)) {
            element1.scrollTop = element1.offsetHeight * .5;
            element1.scrollLeft = element1.offsetWidth * .5;
            if (this.state.loading) {
                this.setState({ loading: false });
            }
        }

        return (
            <Grid item xs className={classes.productImageItem} style={{ width: (Math.trunc(AWidth) + "px") }}>
                <div className="flex mt-12 w-full justify-center">
                    <div className="w-3/5">
                        <React.Suspense fallback={<div></div>}>
                            <Slider
                                className={classes.slider}
                                onChange={(value) => this.changeZoom(value, item.idarquivo)}
                                defaultValue={zoom[item.idarquivo]}
                                step={25}
                                name={"Slider_" + item.idarquivo}
                                graduated
                                progress
                                min={25}
                                max={200}
                                renderMark={mark => {
                                    if ([25, 50, 100, 150, 200].includes(mark)) {
                                        return <span>{mark} %</span>;
                                    }
                                    return null;
                                }}
                            />
                        </React.Suspense>
                    </div>
                </div>
                <div className={"flex flex-col"} style={{ height: (AHeight + "px"), width: (Math.trunc(AWidth) + "px"), overflow: "auto", margin: "1px" }}>
                    <div
                        id={"divMainImg_" + item.idarquivo}
                        key={"divMainImg_" + item.idarquivo}
                        style={{
                            height: (item.height + "px"),
                            //width: (item.width + "px"),
                            width: (item.width * (zoom[item.idarquivo] / 100) + "px"),
                        }}>
                        <div
                            id={"divImageBg_" + item.idarquivo}
                            key={"divImageBg_" + item.idarquivo}
                            className="max-w-none"
                            style={{
                                backgroundImage: "url(data:" + item.base64 + ")",
                                backgroundRepeat: "no-repeat, repeat",
                                height: (item.height * (zoom[item.idarquivo] / 100) + "px"),
                                width: (item.width * (zoom[item.idarquivo] / 100) + "px"),
                                backgroundPosition: "center",
                                backgroundSize: "100%",
                                cursor: "pointer",

                            }}
                            alt={item.nome}
                        />
                    </div>
                </div>
            </Grid>
        );
    };

    handleChange = (event) => {
        this.setState(_.set({ ...this.state }, event.target.name, event.target.value));
    };

    render() {
        const { selected, classes } = this.props;
        const { colunas } = this.state;

        var AContent = [];
        if (selected && selected.length > 0) {
            for (let i = 0; i < selected.length; i = i + colunas) {
                AContent.push(
                    <Grid container xs={12} className={classes.container}>
                        {(colunas >= 1) && (i < selected.length) &&
                            this.getImagem(selected[i])
                        }
                        {(colunas >= 2) && (i + 1) < selected.length &&
                            this.getImagem(selected[(i + 1)])
                        }
                        {(colunas >= 3) && (i + 2) < selected.length &&
                            this.getImagem(selected[(i + 2)])
                        }
                        {(colunas >= 4) && (i + 3) < selected.length &&
                            this.getImagem(selected[(i + 3)])
                        }
                        {(colunas >= 5) && (i + 4) < selected.length &&
                            this.getImagem(selected[(i + 4)])
                        }
                        {(colunas >= 6) && (i + 5) < selected.length &&
                            this.getImagem(selected[(i + 5)])
                        }
                        {(colunas >= 7) && (i + 6) < selected.length &&
                            this.getImagem(selected[(i + 6)])
                        }

                    </Grid>
                );
            }
        }

        return (
            <React.Fragment>
                <div className="flex flex-1 w-full items-center justify-between mt-8 px-16">
                    <TextField
                        className="mb-8"
                        label="Colunas"
                        autoFocus
                        id="colunas"
                        name="colunas"
                        value={colunas}
                        onChange={this.handleChange}
                        variant="outlined"
                        select
                        fullWidth
                        InputLabelProps={{
                            shrink: true,
                        }}
                    >
                        {selected !== null && selected.map((item, x) =>
                            <MenuItem key={x} value={x + 1}>{x + 1}</MenuItem>
                        )}

                    </TextField>
                </div>
                <div className="ml-16">
                    {AContent.map((item) => {
                        return (item);
                    })
                    }
                </div>
            </React.Fragment>
        );
    }
}

function mapStateToProps({ Arquivo }) {
    return {
        Galeria: Arquivo.data,
        selected: Arquivo.selected

    };
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps)(Visualizacao01)));
